var _circle, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ShowPermitCard50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 6,
    x: 22,
    y: 10,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36,14h-8v2c0,1.105-0.895,2-2,2h-4c-1.105,0-2-0.895-2-2v-2h-8c-1.105,0-2,0.895-2,2v16 c0,1.105,0.895,2,2,2h24c1.105,0,2-0.895,2-2V16C38,14.895,37.105,14,36,14z M12,30c0-2.651,1.722-4.897,4.107-5.69 C15.437,23.759,15,22.935,15,22c0-1.657,1.343-3,3-3s3,1.343,3,3c0,0.935-0.437,1.759-1.107,2.31C22.278,25.103,24,27.349,24,30H12z M35,30h-9v-2h9V30z M35,26h-9v-2h9V26z M35,22h-9v-2h9V22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ShowPermitCard50);
export default __webpack_public_path__ + "static/media/icons8-show-permit-card-50.f6bf8a7d7d14d689288cf80bf84d33f3.svg";
export { ForwardRef as ReactComponent };